import { render, staticRenderFns } from "./HowCalculate.vue?vue&type=template&id=3f6f18d7&scoped=true"
import script from "./HowCalculate.vue?vue&type=script&lang=js"
export * from "./HowCalculate.vue?vue&type=script&lang=js"
import style0 from "./HowCalculate.vue?vue&type=style&index=0&id=3f6f18d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f18d7",
  null
  
)

export default component.exports